import React from "react";
import Tabs from "../../../Components/Tabs";
import "./_index.scss";
import "./nps.scss";

const TYPES = ['All', 'Site', 'Doc', 'Article', 'Code', 'Learning Lab', 'Sandbox']//, 'API', 'Ecosystem', "Automation"];
const TYPE_TITLE_MAP = {};

const TABS_CSS = `.dui-basic-tabs {
    justify-content: center;
}

.dui-basic-tabs .basic-tab {
    color: #7d7d7d;
}
@midea(min-width: 1200px) {
    .dui-basic-tabs .basic-tab {
        padding: 0.75em 1.8em;
    }
}
`;

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focused: false,
            keyword: '',
            hasResult: false
        };
    }
    _getItemCountForType(type, statByType) {
        const state = statByType.find(i => i.type == type);
        return state ? state.numCandidates : 0;
    }

    _buildAllStateByType(result) {
        const statByType = (result && result.statSummary ? result.statSummary.statByType : []);
        const allCounts = statByType.reduce((all, i) => {
            return {
                numCandidates: all.numCandidates + i.numCandidates,
                numSelectedTopN: all.numSelectedTopN + i.numSelectedTopN
            }
        }, { numCandidates: 0, numSelectedTopN: 0 });
        return [...statByType, { type: 'All', ...allCounts }];
    }

    _onFocus = (e) => {
        // console.log("_onFocus")
        this.setState({
            focused: true
        });
    }
    _onblur = (e) => {
        // console.log("_onblur")
        this.setState({
            focused: false
        });
    }
    _clearKey = () => {
        // console.log("_clearKey")
        this.setState({ keyword: '' });

    }
    _onInputChange = (e) => {
        // this.props.onChangeSearchKey(e)
        this.setState({ keyword: e.target.value });

    }
    _onKeyDown = (e) => {
        // this.props.onChangeSearchKey(e)
        if (e.key == 'Enter') {
            this.props.onSearch && this.props.onSearch(e.target.value);
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("componentDidUpdate:", this.props.busy, this.props.result)
        if (this.props !== prevProps) {
            // console.log("componentDidUpdate:", this.props.keyword, prevProps.keyword)
            let { keyword } = this.props;
            if(keyword!== prevProps.keyword){
                this.setState({ keyword });
            }
            if (this.props.result?.items?.length) {
                this.setState({ hasResult: true });
            }
        }

    }
    // static getDerivedStateFromProps(props, state) {
    //     console.log("getDerivedStateFromProps:", props.keyword, state.keyword)
    //     return { keyword: props.keyword };
    // }
    componentWillReceiveProps() {

        // console.log("componentWillReceiveProps:", this.props.searchKey, this.state.keyword)
        if (this.props.searchKey !== this.state.keyword) {
            return
        }
        // this.setState({ keyword,hasResult })
        const getLang = () => {
            return (new URL(window.location.href)).searchParams.get("locale") || PubHub.util.cookie.getCookie("devnet_language") || "en";
        };
        // if (this.state.hadSubmit) {
        let npsBoxThank = document.getElementsByClassName("npsBoxThank")[0]
        npsBoxThank?.setAttribute('class', 'npsBox')
        // }
        NpsSDK.loadForm("cdb0flfj46ov714c7j50", {
            type: 'element', // slide, popup,element
            language: getLang(), // Multi-language support
            thresholdScore: 11,//Score threshold, input display when it is less than，
            // thanksMessage: {
            //     message: '',
            // },
            //The prompt message after the form is submitted successfully
            callback: (form) => {
                //If it is written in the callback
                form.setFormMetadata({
                    keyword: this.props.keyword,
                    pageNum: String(this.props.pageNum),
                    selectedTab: this.props.activedType || TYPES[0]
                })

                form.onSubmitSuccess = (function (resp, el) {
                    let dataType = el.getAttribute('data-type')
                    // console.log('onSubmitSuccess-----', resp, el, dataType);
                    if (dataType === "button") {
                        showThank()
                    }


                });



                let npsBox = document.getElementsByClassName("npsBox")[0]
                // console.log("npsBox", npsBox)
                if (npsBox) {
                    NpsSDK.openSurvey();
                }

                function showThank(e) {
                    // e.stopPropagation()
                    let npsBox = document.getElementsByClassName("npsBox")[0]
                    npsBox.setAttribute('class', 'npsBoxThank')

                }
                function addHeight(e) {
                    let npsBox = document.getElementsByClassName("npsBox")[0]
                    npsBox.setAttribute('class', 'npsBox npsBoxClick')

                    let cancelBtn = document.getElementsByClassName("pfb-submit-wrapper")[0]
                    // console.log("addHeight:", cancelBtn)
                    cancelBtn?.setAttribute('id', 'cancelBtn')
                    document.getElementById("cancelBtn").addEventListener("click", clickCancelBtn);
                    e.stopPropagation()
                }

                function clickCancelBtn(e) {

                    let npsBox = document.getElementsByClassName("npsBox")[0]
                    // console.log("reduceHeight:", npsBox)
                    npsBox.setAttribute('class', 'npsBox')
                    form.setValues({ 'c8s12oq0onm9ch2f46d0': 0, 'c8s18720onm9ch2f46dg': '' })
                    e.stopPropagation()
                    // form.reOpen()
                }
                document.getElementById("npsWrap").addEventListener("click", addHeight);


                document.getElementById("root").addEventListener("click", function (e) {
                    // e.stopPropagation()
                    let npsBox = document.getElementsByClassName("npsBox")[0]
                    // console.log("getElementById(root", npsBox)
                    npsBox && npsBox.setAttribute('class', 'npsBox')
                    form.setValues({ 'c8s12oq0onm9ch2f46d0': 0, 'c8s18720onm9ch2f46dg': '' })
                });
            },
        });
    }

    render() {
        const activedType = this.props.activedType || TYPES[0];
        const allStatByType = this._buildAllStateByType(this.props.result);

        const tabHeaders = TYPES.map(type => {
            const typeTitle = TYPE_TITLE_MAP[type] || type;
            const count = !this.props.searchKey ? '' : this._getItemCountForType(type, allStatByType);
            return count ? `${typeTitle} (${count})` : typeTitle;
        });

        return (
            <section className="dn-search-header">
                <div className="container">
                    {
                        this.props.searchKey ?
                            <div className="h1"><div className="h1Title">Search result for:</div> <div className="keyword">{this.props.searchKey}</div>  </div>
                            : <div className="h2">Search</div>
                    }
                    <div className="row">
                        <div className="col">
                            <div className={`searchWrap ${this.state.focused ? 'focused' : ''}`}>
                                <div className="icon"></div>
                                <input type="search" className="form-control search" placeholder="Search"
                                    value={this.state.keyword}
                                    onChange={this._onInputChange}
                                    onFocus={this._onFocus}
                                    onBlur={this._onblur}
                                    onKeyDown={this._onKeyDown}
                                />
                                {/* {
                                    this.state.keyword && this.state.keyword.length ?
                                        (<div className="iconClear" onClick={this._clearKey}></div>)
                                        : ''
                                } */}
                            </div>
                        </div>
                        {
                            this.props.searchKey ?
                                <div className="col npsCol">
                                    <div className="npsBox">
                                        <div className="npsIcon"></div>
                                        <div id="npsWrap"></div>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                </div>
                <div className="dn-search-header-tabs-container">
                    <Tabs
                        selectedIndex={TYPES.findIndex(i => i == activedType || i.replace(/ /g, '') == activedType)}
                        tabs={tabHeaders}
                        onChange={this._onChangeTabIndex}
                        css={TABS_CSS} />
                </div>
            </section>
        )
    }

    _onChangeTabIndex = (selectedIndex) => {
        const tab = selectedIndex == 0 ? '' : TYPES[selectedIndex];
        this.props.onChangeActivedType && this.props.onChangeActivedType(tab);

        if (tab) {
            window.location.hash = '#' + tab.replace(/ /g, '');
        } else {
            window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
        }
    }
}